import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { handleBackTop } from "@/components/BackTop";
import { Input } from "antd";

interface PageNoInputProps {
    pageNo: number | "";

    totalCount: number;

    pageSize: number;

    onPageNoChange?(pageNo: number): void;
}

const PageNoInput: React.FC<PageNoInputProps> = observer(function (props) {
    const { pageNo, totalCount, pageSize, onPageNoChange } = props;

    const [localPageNo, setLocalPageNo] = useState<number | "">(pageNo);

    useEffect(() => {
        setLocalPageNo(pageNo);
    }, [pageNo]);

    const onPageNoInputChange = (e) => {
        const _pageNo = e.target.value ? parseInt(e.target.value, 10) : null;

        if (!_pageNo) {
            setLocalPageNo("");

            return;
        }

        setLocalPageNo(_pageNo);
    };

    const onPageNoInputKeyDown = (e) => {
        const { keyCode } = e;

        const isNumberKey = (keyCode > 47 && keyCode < 58) || (keyCode >= 96 && keyCode <= 105);
        const isControlKey = keyCode === 13 || keyCode === 8; // 删除和回车键
        const isDirectionKey = keyCode === 37 || keyCode === 39;

        if (!isNumberKey && !isControlKey && !isDirectionKey) {
            e.preventDefault();
        }
    };

    const handlePageNoExec = () => {
        const totalPages = Math.ceil(totalCount / pageSize);

        if (localPageNo && (totalPages > localPageNo || totalPages === localPageNo)) {
            handleBackTop();

            onPageNoChange?.(localPageNo);
        }
        // 当前页码超过总数时 设置页码为总数
        else if (localPageNo && totalPages < localPageNo) {
            handleBackTop();

            setLocalPageNo(totalPages);
            onPageNoChange?.(totalPages);
        }
    };

    const onPageNoInputKeyUp = (e) => {
        // keyCode=13为回车键
        if (e.keyCode === 13) {
            handlePageNoExec();
        }
    };

    const onPageNoInputBlur = (e) => {
        if (localPageNo && pageNo === localPageNo) {
            return;
        }

        handlePageNoExec();
    };

    return (
        <Input
            size="small"
            type="text"
            className="ml10"
            style={{ width: 30 }}
            onChange={onPageNoInputChange}
            onKeyDown={onPageNoInputKeyDown}
            onKeyUp={onPageNoInputKeyUp}
            onBlur={onPageNoInputBlur}
            value={localPageNo}
        />
    );
});

export default PageNoInput;
